import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import { Formik } from "formik";
import * as Yup from "yup";
import LoginPage from "./loginPage";
import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  MOBILE_NUMBER,
  REFERENCE_NUMBER,
  TABLE_FILTER_APP,
  TABLE_FILTER_SUPP,
} from "../../config/cacheKey";
import { Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { GetMenus, authenticate } from "../../services/security.service";
import {
  AuthenticateRequest,
  AuthenticateResponse,
  GetSideMenu,
} from "../../models/security.model";
import {
  setForceChangePassword,
  setJwtToken,
} from "../../services/auth.service";
import { GetUsers } from "../../services/chat.service";
import { GetUsersReponse } from "../../models/chat.model";
import MaterialPasswordField from "../../components/textField/MaterialPasswordField";
import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { ShellConfig } from "../../models/common.model";
import { useSelector } from "react-redux";

function _login() {
  const mobileValid = Yup.object({
    mobileNumber: Yup.string().required(),
  });

  const history = useHistory();
  const queryClient = useQueryClient();

  /** getMenus */
  const [dynamicSideMenu, setDynamicSideMenu] = React.useState<boolean>(false);

  React.useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();
  }, []);

  let { data, isLoading } = useQuery<GetSideMenu>(
    "GetSideMenus",
    (): Promise<GetSideMenu> => {
      return GetMenus();
    },
    { enabled: dynamicSideMenu }
  );
  const { mutate: GetUsersMutation } = useMutation(GetUsers, {
    onSuccess: (data: GetUsersReponse[]) => {
      if (data) {
        localStorage.setItem("getMentionusers", JSON.stringify(data));
      }
    },
    onError: () => {},
  });
  /** getMenus */
  const authenticateCall = useMutation(authenticate, {
    onSuccess: (data: AuthenticateResponse) => {
      if (data) {
        queryClient.setQueryData(TABLE_FILTER_SUPP, null);
        queryClient.setQueryData(TABLE_FILTER_APP, null);
        /** getMenus */
        setDynamicSideMenu(true);
        /** getMenus */
        // data.forceChangePassword = true;
        if (data.forceChangePassword) {
          setJwtToken(data.jwt);
          setForceChangePassword(String(data.forceChangePassword));
          history.push("/forceChangePass");
        } else {
          setJwtToken(data.jwt);
          GetUsersMutation();
          setForceChangePassword(String(data.forceChangePassword));
          history.push("/welcome");
        }
      }
    },
  });

  const changeLoginPage = () => {
    history.push("/loginByOtp");
  };

  const validationSchema = Yup.object().shape({
    username: Yup.string().required("نام کاربری اجباری می باشد"),
    password: Yup.string().required("رمز عبور اجباری می باشد"),
  });

  const jsonFile = useSelector((state: any) => state.style);
  return (
    <>
      <Box>
        <Typography
          className="iranSansFaNum"
          color={"#1D4A87"}
          fontSize={"1.2rem"}
          fontWeight={"bold"}
          sx={{
            backgroundColor: "#F9FAFC",
            padding: "18px 30px",
            borderBottom: "1px solid #CFD8DC",
          }}
        >
          <img
            src={jsonFile?.loginLogo}
            style={{
              width: "32px",
              height: "32px",
              objectFit: "cover",
              marginLeft: "10px",
            }}
            alt="compony logo"
          />
          سامانه ستاد ارزش آفرین ثمین
        </Typography>
      </Box>
      <Box sx={{ paddingX: { xs: "1rem", sm: "2rem", md: "8rem" } }}>
        <Typography className="iranSansFaNum textCenter mTop50 mbottom80 textFont22">
          ورود به حساب کاربری
        </Typography>
        <Formik
          initialValues={new AuthenticateRequest()}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            authenticateCall.mutate(values);
          }}
        >
          {({
            handleSubmit,
            handleChange,
            values,
            errors,
            touched,
            handleBlur,
          }) => (
            <form onSubmit={handleSubmit}>
              <MaterialTextFieldComponent
                helperText={!touched.username ? errors.username : ""}
                error={!touched.username && Boolean(errors.username)}
                label="نام کاربری"
                placeHolder={"*نام کاربری خود را وارد کنید "}
                required={true}
                type="text"
                value={values.username}
                onChange={handleChange}
                name="username"
                id="username"
              />

              <br />

              <MaterialPasswordField
                helperText={!touched.password ? errors.password : ""}
                error={!touched.password && Boolean(errors.password)}
                label=" رمز ورود"
                placeHolder={"*رمز ورود خود را وارد کنید "}
                required={true}
                type="password"
                value={values.password}
                onChange={handleChange}
                name="password"
                id="password"
              />

              <Button
                style={{ marginTop: "50px" }}
                type="submit"
                fullWidth
                variant="contained"
                disabled={Object.keys(errors).length > 0}
                className={`${
                  Object.keys(errors).length > 0
                    ? "btnForm deactivatedButton Vazirmatn"
                    : "btnForm activatedButton Vazirmatn "
                }`}
              >
                ورود
              </Button>

              {/* <div
              onClick={changeLoginPage}
              style={{
                marginTop: "30px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <span className="titleCardGreen cursorPointer">
                ورود با شماره همراه
              </span>
            </div> */}
            </form>
          )}
        </Formik>
      </Box>
    </>
  );
}

export default function Login() {
  const childForm = <_login />;
  const queryClient = useQueryClient();
  queryClient.setQueryData("GetCartables", null);
  queryClient.setQueryData("GetCartablesReg", null);
  queryClient.setQueryData("table_filter", null);

  return (
    <Box sx={{ flexGrow: 2, overflow: "hidden", px: 3 }}>
      <LoginPage childForm={childForm} onBtnNext={() => console.log("")} />
    </Box>
  );
}
